<template>
	<div class="cheevo-counter">
		<div class="counter-wrapper">
			<ximg
				src="/img/icons/feed/feed_achievement.svg"
				ariaLabel="acheivment"
				role="img"
			/>
			<strong class="cheevo-counter-number">{{ achievementCount }}</strong>
		</div>
		<div class="in-progress">
			<strong class="top">Achievements</strong>
			<br>
			<strong class="bottom">{{ inProgressCount }} In progress</strong>
		</div>
	</div>
</template>
<script>
export default  {
	props: {
		achievementCount: {
			type: Number,
			default: 0,
		},
		inProgressCount: {
			type: Number,
			default: 0,
		},
	},
};
</script>
